import { makeStyles } from '@mui/styles';
import { selectClasses } from '@mui/material/Select';
import { colors } from 'Constants/Colors';

const dropDownStyle = {
  [`& .${selectClasses.icon}`]: {
    color: colors.GREEN,
  },
  [`& .${selectClasses.select}`]: {
    fontFamily: 'var(--app-font)',
    fontStyle: 'normal',
    fontWeight: 'bold',
    border: 0,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 0,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: '0',
  },
};

export default { dropDownStyle };
